<template>
  <div
    ref="documentListModal"
    aria-hidden="true"
    aria-labelledby="documentListModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div v-if="title" class="modal-header">
          <h5 class="modal-title textStyle">
            {{ title }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <div v-for="(item, index) in list" :key="index" class="card">
            <DocumentCellDataTableComponent :item="item" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import DocumentCellDataTableComponent from "@/components/data-table/cell/DocumentCellDataTableComponent.vue";

export default {
  name: "DocumentContentModalComponentModalComponent",
  components: { DocumentCellDataTableComponent },
  props: {
    list: {
      type: Array,
      required: false,
      default: () => [],
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    opened: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ["emitRowAction"],
  watch: {
    opened() {
      const container = this.$refs.documentListModal;
      const modal = new Modal(container);
      if (this.opened) {
        modal.show();
      } else {
        modal.hide();
        this.$emit("hidden");
      }
    },
  },
  mounted() {
    this.$refs.documentListModal.addEventListener("hidden.bs.modal", this.hidden);
  },
  methods: {
    hidden() {
      this.$emit("hidden");
      const container = this.$refs.documentListModal;
      container.removeEventListener("click", this.stop);
    },

    stop(e) {
      e.stopPropagation();
    },
  },
};
</script>

<style scoped lang="scss">
.modal {
  z-index: 1061;
}
.indicator__container {
  padding: 10px 10px 0 10px;
  font-size: 15px;
}

.card {
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 0 40px 0 rgba(94, 92, 154, 0.06);
  border: 1px solid $m-color_3;
}

.card + .card {
  margin-top: 10px;
}
</style>
